import { Flex, Heading } from '@chakra-ui/react';

type Props = {
  list: any[];
  onClickItem: (item: any, index: number) => void;
  selectedItemIndex: number;
  size?: string;
  wrap?: boolean;
};

function Tab({ list, onClickItem, selectedItemIndex, size, wrap  }: Props) {

  return (
    <Flex flexWrap={wrap ? 'wrap' : 'nowrap'} paddingBottom="10">
      {
      list.map((item:any, index:number) => (
        <button key={index} onClick={() => onClickItem(item, index)}>
          <Heading size={size} paddingRight="6" color={selectedItemIndex === index ? 'b.gr' : 'b.lg'}>{item.label}</Heading>
        </button>
      ))
      }
    </Flex>
  );
}

Tab.defaultProps = {
  size: '2xl'
};

export default Tab;
